import { Reveal } from "../components/Reveal";

export function GritBand() {
  return (
    <section
      data-testid="grit-band"
      className="bg-[#2C3639] px-6 py-[112px] text-center sm:py-[160px]"
    >
      <Reveal className="mx-auto max-w-[820px]">
        <p
          data-testid="grit-line"
          className="text-[1.6rem] font-medium leading-[1.35] tracking-[-0.01em] text-[#A27B5B] sm:text-[2.4rem]"
        >
          <span className="text-[#DCD7C9]">Grit</span> gets our attention.
          <br />
          Character earns our <span className="text-[#DCD7C9]">trust</span>.
          <br />
          <span className="text-[#DCD7C9]">Alignment</span> creates momentum.
        </p>
      </Reveal>
    </section>
  );
}
